// Copyright (c) 2019 Deere & Company

import actions from '../action-types';

export const updateFactoryCode = factoryCode => ( {
    factoryCode,
    type: actions.UPDATE_FACTORY_CODE,

} );

export const loadFactories = factories => ( {
    factories,
    type: actions.LOAD_FACTORIES,
} );
